import React from 'react'

import { ProductIds } from 'core'

import UserInfoItem from './UserInfoItem'

import './ExpenseInfo.less'

interface UserInfoProps {
  name: string
  workEmail: string
  workPhone: string
}

const UserInfo: React.FC<UserInfoProps> = ({ name, workEmail: email, workPhone }) => {
  return (
    <div className="review_expense__user_info p-16  flex__space_between">
      <UserInfoItem title={name} icon="user" />
      <UserInfoItem title={email} icon="envelope" />
      <UserInfoItem title={workPhone ?? 'not set'} icon="phone" />
    </div>
  )
}

export default UserInfo
